import React from "react";

import { FormattedMessage } from "react-intl";
import { MenuItem } from "react-bootstrap";
import { Link } from "../../../../datatypes/ConfiguredLinks";
import { BrandbarPopoverNameComponent } from "./BrandbarPopoverNameComponent";
import { PersonAccountLinksList } from "../businessaccounts/PersonAccountLinksList";
import { BrandbarPopoverAccountComponent } from "../businessaccounts/BrandbarPopoverAccountComponent";
import { BusinessAccountResponse, BusinessAccount } from "../../../../datatypes/businessaccounts/BusinessAccount";
import * as ConfiguredLinksUtil from "../../../../utils/ConfiguredLinksUtil";
import { ProfileLink } from "../businessaccounts/ProfileLink";
import { LogoutLink } from "../businessaccounts/LogoutLink";
import { History } from "history";

type Props = {
    businessAccountData: BusinessAccountResponse | undefined | null;
    activeBusinessAccount: BusinessAccount | undefined | null;
    name: React.ReactNode;
    businessName: string | undefined | null;
    contentToDisplay: number;
    setAccountDropDownPage: (x0: number) => void;
    setClientHeight: (x0: number) => void;
    clientHeight: number;
    history?: History;
};

export class BrandbarPopoverContent extends React.Component<Props> {
    dropdownMenuContent: React.RefObject<HTMLDivElement>;
    constructor(props: Props) {
        super(props);
        this.dropdownMenuContent = React.createRef();
    }

    setHeight() {
        // unfortunately this is neccessary in order to ensure that the popover gets the height of the first page.
        // because of that it has to be passed along to the parent component and passed back in order to not change size.
        // it also have to happen additionally in the componentDidUpdate fct because it does not have the full height after
        // mount
        const element = document.getElementById("dropdownMenuSetHeight");
        if (element && element.style) {
            if (this.props.contentToDisplay === 1) {
                const dropdownMenuContent = this.dropdownMenuContent.current!;
                this.props.setClientHeight(dropdownMenuContent.clientHeight + 24);
                element.style.height = dropdownMenuContent.clientHeight + 24 + "px";
            } else {
                element.style.height = this.props.clientHeight + "px";
            }
        }
    }

    setAccountDropDownPage = (page: number) => {
        this.props.setAccountDropDownPage(page);
    };

    renderLink(link: Link) {
        return (
            <React.Fragment>
                <MenuItem href={link.linkTarget} key={link.linkTarget}>
                    {link.linkText}
                </MenuItem>
                <MenuItem divider />
            </React.Fragment>
        );
    }

    renderConfiguredLinks() {
        return <React.Fragment>{(ConfiguredLinksUtil.getLinksLoginPopup() ?? []).map(this.renderLink)}</React.Fragment>;
    }

    renderContentToDisplay() {
        switch (this.props.contentToDisplay) {
            case 1:
                return this.renderAccountsMenu();
            case 2:
                return this.renderSelectOtherAccount();
            default:
                return null;
        }
    }

    renderProfileAndLogoutMetroX() {
        return (
            <React.Fragment>
                <ProfileLink data={null} history={this.props.history} />
                <MenuItem className="flexed-item make-invisible test-flex-item" />
                <MenuItem divider />
                <LogoutLink data={null} />
            </React.Fragment>
        );
    }

    renderAccountsMenu() {
        return (
            <React.Fragment>
                <BrandbarPopoverNameComponent
                    businessAccountData={this.props.businessAccountData}
                    name={this.props.name}
                    businessName={this.props.businessName}
                    history={this.props.history}
                />
                <MenuItem divider />
                {this.props.activeBusinessAccount && (
                    <BrandbarPopoverAccountComponent businessAccount={this.props.activeBusinessAccount} />
                )}
                {this.props.businessAccountData && (
                    <PersonAccountLinksList
                        businessAccountData={this.props.businessAccountData}
                        setAccountDropDownPage={this.props.setAccountDropDownPage}
                    />
                )}
                {/*Note that the configured links should be rendered for ALL users*/}
                {this.renderConfiguredLinks()}
                {!this.props.activeBusinessAccount && this.renderProfileAndLogoutMetroX()}
            </React.Fragment>
        );
    }

    renderSelectOtherAccount() {
        const accountData = this.props.businessAccountData;
        if (!accountData) {
            return null;
        }

        const labelBack = accountData.labels?.back?.text ?? (
            <FormattedMessage id={"CA_BUSINESS_ACCOUNTS_POPOVER_BACK"} />
        );
        return (
            <React.Fragment>
                <li className="dropdown-menu-item-back test-ba-switch-back">
                    <a
                        href="/"
                        className="clickable"
                        onClick={(e) => {
                            e.preventDefault();
                            this.setAccountDropDownPage(1);
                        }}>
                        <i className="icon-arrow-left" />
                        {labelBack}
                    </a>
                </li>
                {(accountData.accountData ?? []).map((a) => {
                    return (
                        <div key={"ba-" + a.id + "-item"}>
                            <MenuItem divider />
                            <BrandbarPopoverAccountComponent
                                businessAccount={a}
                                key={"business-account-" + a.id}
                                activeAccountId={this.props.businessAccountData?.activeAccountId}
                                showAccountStatus
                                clickable
                            />
                        </div>
                    );
                })}
            </React.Fragment>
        );
    }

    render() {
        return (
            <div className="flyout-menu-item-animation-content" ref={this.dropdownMenuContent}>
                {this.renderContentToDisplay()}
            </div>
        );
    }
}
